import { useTranslation } from 'react-i18next';
import { styled } from 'goober';

import { Stack } from '@/ui/line/line';
import type { Notification } from '@/api/v4/notifications.api';

import { SKELETON_COUNT } from '../constants';
import { NotificationCardSkeleton } from '../skeletons/notification-card-skeleton';
import { EmptyState } from './empty-state';
import { NotificationCard } from '../cards/notification-card';

interface NotificationsContentProps {
  isLoading: boolean;
  notifications: Notification[] | undefined;
}

export const NotificationsContent = ({
  isLoading,
  notifications,
}: NotificationsContentProps) => {
  const { t } = useTranslation('notification');

  if (isLoading) {
    return (
      <List>
        {Array.from({ length: SKELETON_COUNT.NOTIFICATIONS }).map(
          (_, index) => (
            <NotificationCardSkeleton key={`skeleton-${index}`} />
          ),
        )}
      </List>
    );
  }

  if (!notifications || notifications.length === 0) {
    return <EmptyState message={t`noNotifications`} />;
  }

  return (
    <List>
      {notifications.map(notification => (
        <NotificationCard key={notification.id} notification={notification} />
      ))}
    </List>
  );
};

const List = styled(Stack)`
  gap: 12px;
  padding: 12px 20px;
`;
